import { render, staticRenderFns } from "./vesselInformationCard.vue?vue&type=template&id=3f50bec2&scoped=true&"
import script from "./vesselInformationCard.vue?vue&type=script&lang=js&"
export * from "./vesselInformationCard.vue?vue&type=script&lang=js&"
import style0 from "./vesselInformationCard.vue?vue&type=style&index=0&id=3f50bec2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f50bec2",
  null
  
)

export default component.exports